import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import mint from '@tunein/mint';
import flow from 'lodash/flow';
import { bindActionCreators } from 'redux';
import playerStatuses from 'src/common/utils/playerStatuses';
import PlayCircleSolid from 'src/common/components/shared/svgIcons/player/PlayCircleSolid';
import PauseCircleSolid from 'src/common/components/shared/svgIcons/player/PauseCircleSolid';
import cssVariables from 'src/common/styles/variables';
import { PAUSE_PREROLL_ENABLED } from 'src/common/constants/experiments/ads';
import * as PlayerActions from '../../../actions/player';
import connectWithExperiments from '../../../decorators/connectWithExperiments';

export class PrerollMediaButtons extends Component {
  static propTypes = {
    isMinimized: PropTypes.bool.isRequired,
    playerStatus: PropTypes.string.isRequired,
    prerollPlayerStatus: PropTypes.string.isRequired,
    playerActions: PropTypes.object.isRequired,
    [PAUSE_PREROLL_ENABLED]: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.onPauseClick = this.onPauseClick.bind(this);
    this.onPlayClick = this.onPlayClick.bind(this);
  }

  onPauseClick = () => {
    const { [PAUSE_PREROLL_ENABLED]: isPausePrerollEnabled, playerActions } =
      this.props;
    if (isPausePrerollEnabled) {
      playerActions.pause();
    } else {
      mint.pause();
    }
  };

  onPlayClick = () => {
    const { [PAUSE_PREROLL_ENABLED]: isPausePrerollEnabled, playerActions } =
      this.props;
    if (isPausePrerollEnabled) {
      playerActions.play();
    } else {
      mint.play();
    }
  };

  render() {
    const styles = {
      minimized: {
        button: {
          buttonSize: '25',
        },
      },
      expanded: {
        button: {
          buttonSize: '50',
        },
      },
    };
    const {
      playerStatus,
      isMinimized,
      prerollPlayerStatus,
      [PAUSE_PREROLL_ENABLED]: isPausePrerollEnabled,
    } = this.props;
    const playerStatusToUse = isPausePrerollEnabled
      ? playerStatus
      : prerollPlayerStatus;
    const appliedStyles = isMinimized
      ? styles.minimized.button
      : styles.expanded.button;
    return (
      <div>
        {playerStatusToUse === playerStatuses.paused ? (
          <PlayCircleSolid
            width={appliedStyles.buttonSize}
            height={appliedStyles.buttonSize}
            onClick={this.onPlayClick}
            fillButtonBackground={cssVariables['--secondary-color-7']}
          />
        ) : (
          <PauseCircleSolid
            width={appliedStyles.buttonSize}
            height={appliedStyles.buttonSize}
            onClick={this.onPauseClick}
            fillButtonBackground={cssVariables['--secondary-color-7']}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { playerStatus } = state.player;
  const { playerState: prerollPlayerStatus } = state.preroll;

  return {
    prerollPlayerStatus,
    playerStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    playerActions: bindActionCreators(PlayerActions, dispatch),
  };
}

export default flow(
  connect(mapStateToProps, mapDispatchToProps),
  connectWithExperiments([PAUSE_PREROLL_ENABLED]),
)(PrerollMediaButtons);
